/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// eslint-disable-next-line arrow-body-style

'use client'

import React from 'react'
import styles from './googleRating.module.scss'

const seeReviews = () => (
  <p
    className={styles.seeReviews}
    onClick={() => {
      window.open(
        'https://www.google.co.in/maps/place/ACKO+General+Insurance+Limited/@12.8998394,77.6486074,17z/data=!4m7!3m6!1s0x0:0x16c9627005ac5e05!8m2!3d12.8998394!4d77.6507961!9m1!1b1',
        '_blank'
      )
    }}>
    See all reviews
  </p>
)

export default seeReviews
